/** Base path for the v2 create-service-request wizard. */
export const CREATE_SERVICE_REQUEST_BASE_PATH = '/v2/create-service-request';
